import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/Cart/Cart.js
const Cart = createSectionForm({
  icon: "shopping-cart-line",
  title: "Cart",
  fields: [
    { name: "title", label: "Title", placeholder: "Your Cart" },
    { name: "empty_title", label: "Empty Cart Title", placeholder: "Cart is Empty" },
    { name: "empty_button_text", label: "Empty Cart Button", placeholder: "Shop Now" },
  ],
});

export default Cart;
